import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FeatureFlagService } from '../services/feature-flags';

@Injectable({
    providedIn: 'root',
})
export class EnvironmentService {
    private readonly appOrigin$ = new BehaviorSubject<'mykempower' | 'chargeye'>(this.determineAppOrigin());

    constructor(private featureFlagService?: FeatureFlagService) {
        // Listen for feature flag changes that affect app origin
        if (this.featureFlagService) {
            this.featureFlagService.getFlagState$().subscribe(() => {
                const newOrigin = this.determineAppOrigin();
                if (newOrigin !== this.appOrigin$.value) {
                    this.appOrigin$.next(newOrigin);
                }
            });
        }
    }

    private determineAppOrigin(): 'mykempower' | 'chargeye' {
        // Check if MyKempower mode is forced via feature flag
        if (this.featureFlagService?.isEnabled('forceMyKempowerMode')) {
            return 'mykempower';
        }

        const url = window.location.href;
        const includeLocalhost = false; // for development
        const mykempowerPattern = new RegExp(
            `^https?:\\/\\/${includeLocalhost ? 'localhost|' : ''}(?:dev\\.|test\\.)?mykempower\\.com`
        );
        return mykempowerPattern.test(url) ? 'mykempower' : 'chargeye';
    }
    toggle() {
        this.appOrigin$.next(this.appOrigin$.value === 'mykempower' ? 'chargeye' : 'mykempower');
    }

    getAppOrigin$(): Observable<'mykempower' | 'chargeye'> {
        return this.appOrigin$.asObservable();
    }
}
